var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.05337V18.3025M4.5 6.25464C5.76578 6.45067 7.17778 6.77657 8.5 7.28788M4.5 10.2546C5.13949 10.3537 5.8163 10.4859 6.5 10.6584M3.49433 1.01127C5.71271 1.26195 8.69313 1.93632 10.8168 3.42445C11.225 3.71045 11.775 3.71045 12.1832 3.42445C14.3069 1.93632 17.2873 1.26195 19.5057 1.01127C20.6036 0.887209 21.5 1.80402 21.5 2.93518V14.2C21.5 15.3311 20.6036 16.2483 19.5057 16.3723C17.2873 16.623 14.3069 17.2974 12.1832 18.7855C11.775 19.0715 11.225 19.0715 10.8168 18.7855C8.69313 17.2974 5.71271 16.623 3.49433 16.3723C2.39642 16.2483 1.5 15.3311 1.5 14.2V2.93518C1.5 1.80402 2.39642 0.887209 3.49433 1.01127Z",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d337880779342d1ba3b01c0f61b8dd24.svg";
export { ForwardRef as ReactComponent };